export var hashNumbers = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    var hash = 0;
    for (var i = 0; i < values.length; i++) {
        /* tslint:disable:no-bitwise */
        hash = (hash << 5) - hash + values[i];
        hash = hash & hash; // Convert to 32bit integer
        /* tslint:enable:no-bitwise */
    }
    return hash;
};
export var hashString = function (str) {
    return hashNumbers.apply(void 0, str.split('').map(function (char) { return char.charCodeAt(0); }));
};
//# sourceMappingURL=hash.js.map